import groupBy from 'lodash/groupBy'

export default function arrayToDictionary<T, K extends keyof T>(arr: Array<T>, key: K): Record<string, Array<T>> {
  return groupBy(arr, key)
}
